"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_SERVICE_PRICE = exports.GET_SERVICE_CATEGORY_DETAIL = exports.GET_SERVICE_CATEGORY_CAROUSEL = exports.GET_SERVICE_CATEGORY = exports.GET_SERVICES_PACKAGES = exports.GET_MULTIPLE_SERVICE_CATEGORY_DETAIL = exports.GET_LOCATION = exports.GET_CONSENT_FORM = exports.GET_AUTOSUGGEST_HOMECARE_SEARCH = void 0;
const GET_SERVICE_CATEGORY = exports.GET_SERVICE_CATEGORY = 'getServiceCategory';
const GET_SERVICE_CATEGORY_DETAIL = exports.GET_SERVICE_CATEGORY_DETAIL = 'getServiceCategoryDetail';
const GET_SERVICES_PACKAGES = exports.GET_SERVICES_PACKAGES = 'getServicesPackages';
const GET_MULTIPLE_SERVICE_CATEGORY_DETAIL = exports.GET_MULTIPLE_SERVICE_CATEGORY_DETAIL = 'getServiceCategoryDetail';
const GET_CONSENT_FORM = exports.GET_CONSENT_FORM = 'getConsentForm';
const GET_LOCATION = exports.GET_LOCATION = 'getCheckServiceAvailability';
const GET_SERVICE_CATEGORY_CAROUSEL = exports.GET_SERVICE_CATEGORY_CAROUSEL = 'getServiceCategoryCarousel';
const GET_AUTOSUGGEST_HOMECARE_SEARCH = exports.GET_AUTOSUGGEST_HOMECARE_SEARCH = 'getAutoSuggestionHomecareSearch';
const GET_SERVICE_PRICE = exports.GET_SERVICE_PRICE = 'getServicePrice';